import { render, staticRenderFns } from "./PageError.vue?vue&type=template&id=fd6ca20a&scoped=true&"
import script from "./PageError.vue?vue&type=script&lang=js&"
export * from "./PageError.vue?vue&type=script&lang=js&"
import style0 from "./PageError.vue?vue&type=style&index=0&id=fd6ca20a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6ca20a",
  null
  
)

export default component.exports